import { UsersIcon } from 'lucide-react';

import { type IApp } from 'src/graphql/schema';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

import SummaryCard from './SummaryCard';

type Props = {
  app: Pick<IApp, 'ownerName' | 'ownerWebsite'>;
};

const DepositorSummaryCard = ({ app }: Props) => {
  const rows = [
    {
      id: 'organization',
      label: 'Organization',
      value: <span className="font-semibold">{app.ownerName}</span>,
    },
    { id: 'website', label: 'Website', value: app.ownerWebsite || '-' },
  ];

  return (
    <SummaryCard
      icon={UsersIcon}
      title="Depositor information"
      description={`${app.ownerName}'s details — read-only.`}
      note="Non-editable — set by the depositor"
    >
      <Table>
        <TableBody>
          {rows.map(({ id, label, value }) => (
            <TableRow key={id} className="border-0 hover:bg-white">
              <TableCell className="h-10 px-0 w-40 text-xs font-semibold text-muted-foreground py-2.5">
                {label}
              </TableCell>
              <TableCell data-separator className="h-10 w-5 px-0 pr-1 py-2.5 text-slate-400 text-right">
                :
              </TableCell>
              <TableCell className="h-10 py-2.5">
                <div className="min-w-47.5">{value}</div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </SummaryCard>
  );
};

export default DepositorSummaryCard;
